<template>
  <v-card
    class="mx-auto pa-2 overflow-visible"
    outlined
  >
    <v-list-item>
      <v-list-item-content class="overflow-visible">
        <v-list-item-title class="headline mb-2">
          Báo cáo doanh thu
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>


    <v-list-item v-if="Object.keys(chartData).length">
      <v-list-item-title class="headline mb-2 text-center">
        Tổng doanh thu = {{ formatPrice(+total) }}
      </v-list-item-title>
    </v-list-item>

    <chartist 
      ratio="ct-major-second"
      type="Pie"
      :data="chartData"
      :options="chartOptions"
      v-if="Object.keys(chartData).length"
    />

    <ul class="description" v-if="Object.keys(chartData).length">
      <li v-for="(item, index) in title" :key="index" class="d-inline-flex align-items-center">
        <v-avatar
          tile
          v-bind:style="{'background-color':color[index % 10]}"
          size="20"
          class="mx-1"
        />
        {{item}}
      </li>
    </ul>

    <common-no-result
      v-if="!Object.keys(chartData).length"
    />

  </v-card>
</template>

<script>

import { colorChart } from '@/helpers/constants'
import * as moment from 'moment'
import * as ChartistTooltips from 'chartist-plugin-tooltips';
import { formatPrice } from '@/helpers/utils'

import RepositoryFactory from "@/repositories/RepositoryFactory";
const ReportRepository = RepositoryFactory.get('report');

export default {
  props: {
    filterForm: {
      default: () => ({})
    },
  },
  data () {
    return {
      chartData: {},
      chartOptions: {
        height: 300,
        plugins: [this.$chartist.plugins.tooltip(
          {
            currency: ' ',
            // appendToBody: true
          }
        )]
      },
      color: colorChart,
      title: [],
      total: 0
    }
  },
  created() {
    this.fetchData()
    Bus.$on('revenue-report-thpt', () => {
      this.fetchData()
    })
  },
  beforeDestroy() {
    Bus.$off('revenue-report-thpt')
  },
  methods: {
    async fetchData() {
      const loader = this.$loading.show()
      const params = {
        startDateTime: moment(this.filterForm.dateRange.startDate).format('YYYY-MM-DD 00:00:00'),
        endDateTime: moment(this.filterForm.dateRange.endDate).format('YYYY-MM-DD 23:59:59'),
        schoolLevelIds: [2]
      };
      const result = await ReportRepository.fetchTurnover(params)
      loader.hide()
      
      if (result.success) {
        const response = _.get(result, 'data', {})

        if(+response.total === 0) return this.chartData = {}

        const mergeData = [
          {
            percent: +response.oldTurnOverPercent,
            turnOver: +response.oldTurnOver,
            title: 'Doanh thu nhóm số cũ',
          }, {
            percent: +response.newTurnOverPercent,
            turnOver: +response.newTurnOver,
            title: 'Doanh thu nhóm số mới',
          }
        ]

        const series = []
        const labels = []
        const title = []
        mergeData.forEach(e => {
          if(e.percent != 0) {
            series.push({
              meta: e.title,
              value: +e.turnOver
            })
            labels.push( +e.percent + '%' )
            title.push(e.title)
          }
        })
        this.chartData = {
          series: series,
          labels: labels
        }
        this.title = title

        this.total = response.total
      }
    }
  },
}
</script>